// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1921":"7cd2e3e05ed005bb","2888":"a9c797d3e3327679","7482":"7cd2e3e05ed005bb","7526":"94eef746660fc632","7557":"94eef746660fc632","8625":"7cd2e3e05ed005bb"}[chunkId] + ".css";
};